import { Button, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

export function ForbiddenPage() {
  return (
    <Stack align="flex-start">
      <Title order={2}>Accès non autorisé</Title>
      <Text c="dimmed">
        Votre rôle ne donne pas accès à cette page. Contactez l'administrateur si vous en avez
        besoin.
      </Text>
      <Button component={Link} to="/">
        Retour au tableau de bord
      </Button>
    </Stack>
  );
}
